export const header = {
    contactUs: 'Contact Us',
    viewAll: 'View all —',
    ariaMenu: 'Toggle menu',
    navItems: [
        {
            label: 'Why Venus', href: '/#why-venus', id: 'why-venus',
            children: [
                { label: 'Business Climate', href: '/#business-climate' },
                { label: 'Johnson/Ellis Counties', href: '/#counties' },
                { label: 'Venus Living', href: '/#venus-living' },
                { label: 'Affordability', href: '/#affordability' },
                { label: 'Education', href: '/#education' },
                { label: 'Stories of Success', href: '/#stories' },
                { label: 'History of Venus', href: '/history' },
            ],
        },
        {
            label: 'Site Selection', href: '/#site-selection', id: 'site-selection',
            children: [
                { label: 'Demographics', href: '/#demographics' },
                { label: 'Key Industries', href: '/#key-industries' },
                { label: 'Retail in Venus', href: '/#retail' },
                { label: 'Major Employers', href: '/#employers' },
                { label: 'Transportation & Location', href: '/#transportation' },
                { label: 'Utilities & Infrastructure', href: '/#utilities' },
                { label: 'Recent Developments', href: '/#recent-developments' },
            ],
        },
        {
            label: 'Business Resources', href: '/#business-resources', id: 'business',
            children: [
                { label: 'Expansion & Relocation', href: '/#expansion' },
                { label: 'Starting a Business', href: '/#starting-business' },
                { label: 'Incentives', href: '/#incentives' },
                { label: 'Tax Rates', href: '/#tax-rates' },
                { label: 'Research, Data & Mapping', href: '/#research' },
                { label: 'Community Resource Partners', href: '/#partners' },
                { label: 'Job Research', href: '/#job-research' },
            ],
        },
        {
            label: 'Properties', href: '/#space', id: 'space',
            children: [
                { label: 'Property Search', href: '/#property-search' },
            ],
        },
        {
            label: 'About Us', href: '/#about-us', id: 'about',
            children: [
                { label: 'What We Do', href: '/#what-we-do' },
                { label: 'What is an EDC?', href: '/#what-is-edc' },
                { label: 'Meet the Staff', href: '/#staff' },
                { label: 'Meetings & Agendas', href: '/#meetings' },
                { label: 'Latest News', href: '/#news' },
                { label: 'Board Members', href: '/#board' },
            ],
        },
    ],
};

export const hero = {
    subtitle: 'Economic Development',
    title1: 'Where It All ',
    titleSpan: 'Comes Together',
    description: 'Venus, Texas provides a stable, low-cost environment with a supportive community, ideal for launching your new venture or expanding your footprint. With unprecedented growth and strategic location, discover why businesses choose Venus.',
    ctaPrimary: 'Find Your Space',
    ctaSecondary: 'Why Venus?',
    stat1Label: 'SF Industrial Space',
    stat2Label: 'to Dallas Core',
    stat3Label: 'Development Sites',
};

export const cityViews = {
    title: 'Why ',
    titleSpan: 'Venus?',
    subtitle: 'Less than a decade ago, Venus was a growing bedroom community. Not anymore. Today, we have millions of square feet of industrial space filled with more to come in the next 18 months.',
    readStory: 'Read Our Story',
    items: [
        { title: 'Business Climate', description: 'The City Council, and the Venus Service Community Development Corporation (VSCDC) are here to help you grow, and expand your business in Venus, Texas.' },
        { title: 'Opportunities in Venus', description: 'Whether it is a business start-up or an established corporation, the VSCDC will partner with you to aid in anything from site location, navigate permitting process, and help.' },
        { title: 'Plenty of room to establish businesses', description: 'The City of Venus offers prime commercial properties along US Highway 67, and Main Street. If you are looking for a large-scale distribution center, pad sites ready to build, or small retail properties.' },
        { title: 'Johnson/Ellis Counties Continuous Growth', description: 'Venus is located south of Arlington in between Fort Worth and Dallas, within one of the fastest-growing areas in the nation.' },
        { title: 'Business Friendly', description: 'Venus has a service and pro-business mentality with the goal to help businesses and residents alike to relocate here.' },
        { title: 'Venus Living & Affordability', description: 'Venus is a small, vibrant and charming city. Affordable housing ensures that people can meet their basic needs while maintaining access to other essentials.' },
    ],
};

export const whyVenus = {
    businessClimate: {
        label: 'Why Venus',
        title: 'Business ',
        titleSpan: 'Climate',
        subtitle: 'A thriving downtown square, a growing economy, and a community built for business.',
        photoCaption: 'Venus Town Square — Downtown Venus, Texas',
        cards: [
            { icon: '📈', title: 'Rapid Growth',    body: 'Venus is one of the fastest-growing cities in the DFW metroplex, with consistent population and retail expansion year over year.' },
            { icon: '🏗',  title: 'Pro-Business',   body: 'Streamlined permitting, low tax rates, and a city council committed to economic development make Venus a prime destination for investment.' },
            { icon: '🤝',  title: 'Strong Community',body: 'An engaged local business community, active EDC, and a supportive population create the perfect environment to launch and grow.' },
        ],
    },
    venusLiving: {
        label: 'Venus Living',
        title: 'A City Worth ',
        titleSpan: 'Calling Home',
        p1: 'Venus is a small, vibrant and charming city located in Johnson/Ellis counties. Just 30 miles south of Dallas, Venus has easy access in a short drive to all the amenities offered by the Dallas/Fort Worth metroplex area while maintaining family-friendly attributes.',
        p2: 'Venus developed at the junction of the International Great Northern and the Gulf, Colorado and Santa Fe railroads. The railroad made the town a visitor center with commerce, shops, and people who wanted to stay in town. Today, the city continues with that friendly mentality, family-oriented charm and welcomes businesses to be in Venus.',
    },
    affordability: {
        title: 'Affordable ',
        titleSpan: 'Living',
        subtitle: 'Affordable housing ensures that people can meet their basic needs while maintaining access to other essentials like food, healthcare, education, and transportation.',
        ellisLabel: 'Ellis County',
        ellisSubLabel: 'Median Close Price',
        johnsonLabel: 'Johnson County',
        johnsonSubLabel: 'Median Close Price',
        source: 'Data: Texas A&M University, Texas Real Estate Research Center · Accessed: March 2026',
    },
    education: {
        label: 'Education',
        title: 'Venus ',
        titleSpan: 'Independent School District',
        p1: 'The Venus Independent School District (VISD) was founded in 1914. Located 25 miles south of the Dallas-Fort Worth metroplex, Venus ISD serves over 2,300 students.',
        p2: 'VISD offers a friendly community with many opportunities for students to thrive and excel — making Venus an ideal place for families to plant roots and grow alongside your business.',
        cta: 'Visit VISD',
    },
    stories: {
        title: 'Stories of ',
        titleSpan: 'Success',
        subtitle: 'Local businesses that have found their home — and their success — right here in Venus, Texas.',
    },
};

export const stats = {
    title: 'Site Selection & ',
    titleSpan: 'Data',
    subtitle: 'Venus provides a stable, low-cost environment with a supportive community, ideal for launching your new venture or growing your existing business.',
    cta: 'View Full Demographics',
    items: [
        { label: '2025 Population' },
        { label: 'Median Household Income' },
        { label: 'Median Age' },
        { label: 'Yearly Sales Tax Increase' },
    ],
};

export const siteSelection = {
    title: 'Site ',
    titleSpan: 'Selection',
    subtitle: 'Everything you need to make an informed decision about locating your business in Venus, Texas.',
    demographics: {
        title: 'Demographics',
        body: 'Venus has experienced rapid growth in the last decade because people are attracted to the sense of community, and the trend indicates no slowdown any time soon. Venus welcomes your business. With a population that has more than doubled over the past 20 years, In just 30 minutes, businesses have access to more than 95,000 potential employees.',
        statsTitle: 'City of Venus at a Glance',
        stats: {
            population: 'Total Population',
            employment: 'Employment Rate',
            income: 'Median Household Income',
            housing: 'Total Housing Units',
            homeownership: 'Homeownership Rate',
            bachelors: "Bachelor's Degree or Higher",
            uninsured: 'Without Healthcare Coverage',
            medianAge: 'Median Age',
            familySize: 'Average Family Size',
            under18: 'Under 18 Years Old',
        },
        sourceCensus: '2020 Decennial Census.',
        sourceAcs: '2024 American Community Survey 5-year Estimates.',
        estimatesTitle: 'Annual Population Estimates, April 2020 to July 2025',
        estimatesBase: 'April 1, 2020 Estimates Base',
        cityOfVenus: 'City of Venus',
        estimatesSource: 'Population estimates as of July 1. Source: U.S. Census Bureau, Population Division, Annual Estimates of the Resident Population for Incorporated Places in Texas: April 1, 2020 to July 1, 2025 (SUB-IP-EST2025-POP-48). Released May 2026.',
        projectionsTitle: 'County Population Projections',
        county: 'County',
        projectionYears: ['April 2020', 'July 2030', 'July 2040', 'July 2050', 'July 2060'],
        change: 'Change 2020–2060',
        pctChange: '% Change 2020–2060',
        projectionsSource: 'Source: Texas Demographic Center, accessed October 2026.',
    },
    keyIndustries: {
        title: 'Key Industries',
        body: 'Venus has a pro-business attitude and a willingness to welcome new businesses to our community. The Venus Community Service Development Corporation strives to come alongside your business to ensure that Venus is a good fit for your company whether your business is looking to relocate or expand.',
    },
    retail: {
        title: 'Retail in Venus',
        body: 'Venus has seen tremendous growth in the retail sector. The steady increase in population, the lower home prices in the area, and the intersection of US Highway 67 and S FM 157 play a major role in driving retail activity in the community. The City of Venus offers prime commercial properties along US Highway 67 and Main Street — from large-scale pad sites to charming historic downtown storefronts.',
    },
    employers: {
        title: 'Major Employers',
        items: [
            { name: 'Venus ISD', detail: 'Largest employer in the city' },
            { name: 'City of Venus', detail: 'Municipal government & services' },
        ],
    },
    transportation: {
        title: 'Transportation & Location',
        body: 'Venus, Texas is located 30 miles south of the Dallas Central Business District, with its city limits extending into Johnson and Ellis Counties. Venus is located right in the middle of the US Highway 67 corridor between Midlothian and Alvarado. It is projected that SH Highway 360 will align just outside current city limits, providing a boom in business for our city. There is no better time to come to Venus.',
    },
    utilities: {
        title: 'Utilities & Infrastructure',
        body: 'The City of Venus is serviced well by a wide range of utility providers. Wherever your business may fall within the city, you will have access to reliable utilities.',
    },
    recentDev: {
        title: 'Recent Developments',
        intro: 'Venus is growing fast. New businesses choosing Venus include:',
        moreChip: '+ more under construction',
    },
};

export const businessResources = {
    title: 'Business ',
    titleSpan: 'Resources',
    subtitle: 'Everything you need to start, grow, or relocate your business in Venus, Texas.',
    expansion: {
        title: 'Expansion & Relocation',
        body: 'The Venus Community Service Development Corporation strives to increase local employment opportunities that strengthen the local tax base through the financial support of business relocation and expansion. Whether it is a business start-up or an established corporation, the VSCDC will partner with you — from site location to navigating the permitting process.',
    },
    startingBusiness: {
        title: 'Starting a Business',
        intro: 'Below you will find a list of items to be considered when starting a new business in Venus, Texas. Some items may not apply to your specific business type.',
        categories: [
            {
                id: 'city-county',
                title: 'City of Venus & Johnson and Ellis County',
                items: [
                    { name: 'Assumed Name Certificate', desc: 'If operating under an assumed name, file with the Johnson County Clerk or Ellis County Clerk. Contact the respective office to verify name availability.', links: [{ label: 'Johnson County Clerk', href: 'https://www.johnsoncountytx.org/departments/county-clerk' }, { label: 'Ellis County Clerk', href: 'https://www.co.ellis.tx.us/164/County-Clerk' }] },
                    { name: 'Certificate of Occupancy', desc: 'No building shall be occupied or used until a Certificate of Occupancy is issued by the City of Venus.', links: [{ label: 'City of Venus', href: 'https://www.cityofvenus.org' }] },
                    { name: 'Utilities', desc: 'Information about utility connection, fees, and services can be obtained from the City of Venus.', links: [{ label: 'City of Venus', href: 'https://www.cityofvenus.org' }] },
                    { name: 'Area Wage Survey Information', desc: 'Wage and labor market data available from the Bureau of Labor Statistics.', links: [{ label: 'Bureau of Labor Statistics', href: 'https://www.bls.gov' }] },
                ],
            },
            {
                id: 'state',
                title: 'State of Texas Requirements',
                items: [
                    { name: 'Texas Secretary of State', desc: 'For corporate certificates and filing of articles of incorporation, or authority of foreign corporations to do business in Texas.', links: [{ label: 'Secretary of State', href: 'https://www.sos.state.tx.us' }] },
                    { name: 'State Licensing Information', desc: 'Check with the State to determine if any statewide permits or licenses are required for your business type.', links: [{ label: 'Texas.gov', href: 'https://www.texas.gov' }] },
                    { name: 'Sales & Use Taxes', desc: 'Contact the Texas State Comptroller\'s office for information on Sales Taxes, Store Taxes, and other state-administered laws.', links: [{ label: 'Texas Comptroller', href: 'https://comptroller.texas.gov' }] },
                    { name: 'Unemployment Insurance, Taxes & Benefits', desc: 'Obtain information from the Texas Workforce Commission regarding unemployment insurance, tax, and benefits to qualifying employees.', links: [{ label: 'Texas Workforce Commission', href: 'https://www.twc.texas.gov' }] },
                ],
            },
            {
                id: 'federal',
                title: 'Federal Requirements and Regulations',
                items: [
                    { name: 'Apply for an EIN', desc: 'Secure a copy of the "Application for Employer Identification Number" (Form SS-4) from the Internal Revenue Service.', links: [{ label: 'IRS — Apply for EIN', href: 'https://www.irs.gov/businesses/small-businesses-self-employed/apply-for-an-employer-identification-number-ein-online' }] },
                    { name: 'Fair Labor Standards Act (FLSA)', desc: 'Employers must maintain records on wages and hours and display required posters where employees can see them.', links: [{ label: 'DOL — FLSA Guide', href: 'https://www.dol.gov/agencies/whd/flsa' }] },
                    { name: 'Bureau of Labor Statistics', desc: 'Obtain information on laws that relate to employers and workplace safety.', links: [{ label: 'BLS', href: 'https://www.bls.gov' }] },
                    { name: 'Small Business Administration', desc: 'Information about management, procurement, and loan programs to assist small businesses.', links: [{ label: 'SBA', href: 'https://www.sba.gov' }] },
                    { name: 'Occupational Safety and Health Act', desc: 'Requirements to comply with OSHA of 1970, obtainable from OSHA or the Texas Department of Insurance.', links: [{ label: 'OSHA', href: 'https://www.osha.gov' }, { label: 'Texas Dept. of Insurance', href: 'https://www.tdi.texas.gov' }] },
                ],
            },
            {
                id: 'industry',
                title: 'Industry Specific Requirements',
                items: [
                    { name: 'Texas Alcoholic Beverage Commission', desc: 'Licenses and fees for the sale, transportation, or storage of alcoholic beverages.', links: [{ label: 'TABC', href: 'https://www.tabc.texas.gov' }] },
                    { name: 'Health Permits', desc: 'Firms involved in handling, processing, packing, or warehousing of foods must obtain health permits from the City of Venus.', links: [{ label: 'City of Venus', href: 'https://www.cityofvenus.org' }] },
                    { name: 'Import and Export Procedures', desc: 'Information concerning import and export procedures from the International Trade Division or the SBDC.', links: [{ label: 'International Trade', href: 'https://www.trade.gov' }, { label: 'SBDC', href: 'https://www.txsbdc.org' }] },
                    { name: 'Environmental Quality Requirements', desc: 'Environmental control requirements from the Texas Commission on Environmental Quality or the EPA.', links: [{ label: 'TCEQ', href: 'https://www.tceq.texas.gov' }, { label: 'EPA', href: 'https://www.epa.gov' }] },
                ],
            },
            {
                id: 'sbdc',
                title: 'Small Business Development Centers — North Texas',
                items: [
                    { name: 'Small Business Administration', desc: 'Information on start-up and all aspects of running a small business, including downloadable programs.', links: [{ label: 'SBA', href: 'https://www.sba.gov' }] },
                    { name: 'Texas Economic Development Corporation', desc: 'The official Texas Economic Development Division within the Office of the Governor.', links: [{ label: 'Texas EDC', href: 'https://gov.texas.gov/business' }] },
                    { name: 'Texas SBDC Network', desc: 'The Texas Small Business Development Center Network — knowledge, tools, and resources to succeed.', links: [{ label: 'Texas SBDC', href: 'https://www.txsbdc.org' }] },
                    { name: 'Texas.gov', desc: 'Collection of information needed when starting a new business in Texas.', links: [{ label: 'Texas.gov', href: 'https://www.texas.gov' }] },
                    { name: 'SCORE', desc: 'Free mentoring and resources for small business start-up assistance.', links: [{ label: 'SCORE', href: 'https://www.score.org' }] },
                    { name: 'Texas Workforce Commission', desc: 'Local/state network dedicated to developing the workforce of Texas.', links: [{ label: 'TWC', href: 'https://www.twc.texas.gov' }] },
                    { name: 'Texas Manufacturing Assistance Center (TMAC)', desc: 'Local resource to address the challenges of today\'s competitive business environment.', links: [{ label: 'TMAC', href: 'https://www.tmac.org' }] },
                    { name: 'Dallas Black Chamber of Commerce', desc: 'Advocate for the creation, growth, and welfare of African American businesses in the Dallas community.', links: [{ label: 'Dallas Black Chamber', href: 'https://www.dallasblackchamber.org' }] },
                    { name: 'Greater Dallas Hispanic Chamber of Commerce', desc: 'Business resource, forum, and advocate for Hispanic businesses in the greater Dallas area.', links: [{ label: 'Hispanic Chamber', href: 'https://gdahcc.com' }] },
                    { name: "Women's Business Centers", desc: "SBA's resources and information for women-owned businesses.", links: [{ label: "Women's Business Centers", href: 'https://www.sba.gov/local-assistance/resource-partners/womens-business-centers' }] },
                    { name: 'FranNet — Franchise Consultants', desc: 'Consulting company that evaluates potential franchise businesses for prospective owners.', links: [{ label: 'FranNet', href: 'https://frannet.com' }] },
                    { name: 'American Association of Franchisees & Dealers', desc: 'Resources to help you understand and explore a franchise business opportunity.', links: [{ label: 'AAFD', href: 'https://www.aafd.org' }] },
                    { name: 'SBA Guide to Starting Businesses', desc: "SBA's comprehensive section of resources to get your business started.", links: [{ label: 'SBA Business Guide', href: 'https://www.sba.gov/business-guide' }] },
                    { name: 'Intuit QuickBooks Small Business Center', desc: 'A compilation of finance, Human Resources, and marketing resources for small businesses.', links: [{ label: 'QuickBooks SBC', href: 'https://quickbooks.intuit.com/r/small-business-center/' }] },
                ],
            },
        ],
    },
    incentives: {
        title: 'Incentives',
        items: [
            { name: 'Building Improvement Grant (BIG)', desc: 'Financial support for improving existing buildings.' },
            { name: 'Economic Development Incentive Application', desc: 'Apply for customized incentive packages.' },
            { name: 'Tax Abatement', desc: 'Reduce property taxes during your growth phase.' },
            { name: 'Chapter 380 Agreement', desc: 'Sales tax rebate agreements for qualifying businesses.' },
            { name: 'Tax Increment Reinvestment Zone (TIRZ)', desc: 'Reinvest tax increments to support development.' },
        ],
    },
    taxRates: {
        title: 'Tax Rates',
        asOf: 'as of October 1, 2026',
        propSubtitle: 'Property Tax Rate (per $100 value)',
        salesSubtitle: 'Sales & Use Tax Rate',
        propRates: [
            { label: 'Johnson County', rate: '$0.417000 per $100' },
            { label: 'Ellis County', rate: '$0.273500 per $100' },
            { label: 'City of Venus', rate: '$0.785967 per $100' },
            { label: 'Venus ISD', rate: '$1.237100 per $100' },
        ],
        salesRates: [
            { label: 'City of Venus', rate: '2.00%' },
            { label: 'State of Texas', rate: '6.25%' },
            { label: 'Total', rate: '8.25%', bold: true },
        ],
    },
    research: {
        title: 'Research, Data & Mapping',
        maps: ['Zoning Map', 'Future Land Use Map', 'Historic Overlay'],
    },
    partners: {
        title: 'Community Resource Partners',
        items: ['Workforce Development & Training', 'Planning Department', 'Building Department', 'Public Works'],
    },
    jobResearch: {
        title: 'Job Research',
        links: [
            { name: 'Texas Municipal League', href: 'https://www.tml.org' },
            { name: 'Work in Texas', href: 'https://www.workintexas.com' },
        ],
    },
};

export const properties = {
    title: 'Find Your ',
    titleSpan: 'Space',
    subtitle: 'Whether you are looking for a build-to-suit industrial facility or a charming storefront, Venus has the perfect location for your business.',
    forSale: 'For Sale',
    forLease: 'For Lease',
    listings: 'listings',
    viewDetails: 'View details',
    cards: [
        { title: 'Property Search', desc: 'Browse our comprehensive database of available commercial and industrial properties in Venus.', cta: 'Search Properties' },
        { title: 'Industrial Spec', desc: '3.5M SF of industrial spec space ready for your manufacturing or distribution needs.', cta: 'Learn More' },
        { title: 'Retail & Downtown', desc: 'Join the vibrant mix of local shops and national brands in our expanding retail corridors.', cta: 'Learn More' },
    ],
};

export const aboutUs = {
    title: 'About ',
    titleSpan: 'Us',
    whatWeDo: {
        title: 'What We Do',
        body: 'The Venus Community Service Development Corporation strives to increase local employment opportunities that strengthen the local tax base through the financial support of business relocation and expansion. The VSCDC is proactive to help existing and prospective businesses develop and thrive by creating opportunities for sustainable growth.',
    },
    missionStatement: {
        title: 'Mission Statement',
        body: 'Promoting economic development and community well-being in the City of Venus through the strategic development of business, tourism, parks, and entertainment.',
    },
    whatIsEdc: {
        title: 'What is an EDC?',
        intro: 'An Economic Development Corporation (EDC) is a sales tax funded vehicle by which communities can engage in economic and community development activities. EDCs create economic development programs, build infrastructure, train and educate the local workforce, foster partnerships with other government entities, and undertake projects that improve the quality of life of a community\'s residents.',
        sections: [
            {
                id: 'types',
                title: 'Type A vs. Type B Corporations',
                body: 'There are two types of EDC corporations depending on the size of the community and how it wishes to use its sales tax revenues. The minimum sales tax rate is 1/8 of one percent. Cities can have both types; however, the combined local sales tax cannot exceed 2%.',
                subsections: [
                    { name: 'Type A EDC', content: 'More restricted in the kinds of projects it can fund. May only be formed in counties with fewer than 500,000 people.', list: null },
                    { name: 'Type B EDC', content: 'More loosely defined — expands uses to include a wide array of economic development projects, infrastructure improvements, and quality of life initiatives. Can be formed in any city in Texas, regardless of size or location.', list: null },
                ],
                list: null,
            },
            {
                id: 'sales-tax',
                title: 'Who Collects the Sales Taxes?',
                body: 'The tax is collected by the Texas Comptroller of Public Accounts. 6.250% is the statewide sales tax. Local communities and EDCs can elect to add an additional sales tax of up to 2% for a total of 8.250%. A portion of this additional 2% is what EDCs use to fund allowable projects and operating expenses.',
                subsections: null,
                list: null,
            },
            {
                id: 'primary-job',
                title: 'What is a Primary Job?',
                body: 'A primary job is an employment position at a company for which a majority of its products or services are ultimately exported to regional, statewide, national, or international markets, infusing new dollars into a local economy. It must also be included in one of the following NAICS sectors:',
                subsections: null,
                list: ['Crop production', 'Animal production', 'Forestry and logging', 'Commercial fishing', 'Support Activities for agriculture and forestry', 'Mining', 'Utilities', 'Manufacturing', 'Wholesale trade', 'Transportation', 'Warehousing', 'Information & data services', 'Securities, commodities, insurance, and other financial activities', 'Scientific research', 'Development services', 'Management companies and enterprises', 'Telephone call centers', 'Correctional institutions', 'National security'],
            },
            {
                id: 'type-a-projects',
                title: 'Type A EDC Projects',
                body: null,
                list: null,
                subsections: [
                    {
                        name: 'Primary Job Projects',
                        content: 'Include land, buildings, equipment, facilities, improvements, and expenditures for the creation and retention of "primary jobs" — suitable for:',
                        list: ['Manufacturing', 'Industrial', 'Research & Development', 'Recycling', 'Small warehouses', 'Distribution centers', 'Regional or national corporate headquarters', 'Closed or realigned military bases', 'Primary job training facilities by higher education institutions'],
                    },
                    {
                        name: 'Non-Primary Job Projects',
                        content: null,
                        list: ['Job training classes and career centers', 'Business airport facilities and port related facilities', 'Clean-up of contaminated project sites (with special election)', 'Infrastructure assistance to retail or commercial projects', 'Business-related sewer utilities and site improvements', 'Beach remediation in Gulf communities', 'Projects to attract or retain military missions', 'General airport facilities within 25 miles of the USA/Mexico border', 'Light rail, commuter rail, and motor buses', 'Sports venue facilities (with special election and ballot language)', 'Any Type B project via special election and voter approval'],
                    },
                ],
            },
            {
                id: 'type-b-projects',
                title: 'Type B EDC Projects',
                body: null,
                subsections: null,
                list: ['Everything authorized under Type A, including retail and commercial projects', 'Water supply facilities (with special election and ballot language)', 'Projects to improve a community\'s "quality of life" — parks, sports, tourism, and entertainment facilities', 'Affordable housing projects', 'Any improvement promoting "new or expanded business" activity that creates or retains "primary jobs"', 'Direct incentives for retail in communities with fewer than 200,000 residents', 'Sewer or solid waste facilities in Hidalgo County', 'Hangars, airport maintenance, air cargo facilities, and related airport infrastructure', 'Rail ports, rail switching facilities, marine ports, and inland ports'],
            },
            {
                id: 'incentives',
                title: 'Local Economic Development Incentives',
                body: null,
                list: null,
                subsections: [
                    {
                        name: 'Performance Agreements',
                        content: 'EDCs cannot simply provide gifts of sales tax proceeds. A performance agreement (contract) is required under Chapter 501 of the Texas Local Government Code before any funds may be provided — regardless of amount. Must be approved by both the EDC board and the City Council. The agreement must:',
                        list: ['Be signed by the parties', 'Set forth a schedule of additional payroll, jobs, or metrics for economic impact', 'Outline in dollars the capital investment to be made by the business', 'Contain the amount of funds or incentives provided', 'Include repayment terms if the business fails to meet its obligations', 'Contain statutory legal disclaimers under the Texas Tax Code, Government Code, and Local Government Code'],
                    },
                    { name: 'Chapter 380 Agreement (for cities)', content: 'Loans for infrastructure and other improvements designed for economic development.', list: null },
                    { name: 'Chapter 381 Agreement (for counties)', content: 'Allows contracting with private entities to share in infrastructure and utility expenses and planning.', list: null },
                    { name: 'Property Tax Abatement', content: 'Under Chapters 311–313 of the Texas Tax Code, cities and counties may initiate a tax abatement allowing a business to pay a portion of property taxes on their land and/or improvements for a fixed agreed period. Abatement agreements cannot exceed ten (10) years.', list: null },
                    { name: 'Tax Increment Reinvestment Zone (TIRZ)', content: 'Under Chapter 311 of the Texas Tax Code, the TIRZ helps address needs such as deteriorating structures, roads in need of repair, sidewalks, unsanitary or unsafe conditions, or other defective conditions with property, structures, or utilities.', list: null },
                ],
            },
        ],
    },
    staff: { title: 'Meet the Staff' },
    directorBadge: 'EDC Director',
    directorOrg: 'Venus Community Service Development Corporation',
    directorCta: 'View full profile →',
    board: { title: 'Board Members' },
    viewProfile: 'View profile →',
    vacantName: 'Vacant',
    vacantRole: 'Board Member',
    meetings: {
        title: 'Meetings & Agendas',
        body: 'Official minutes and agendas are published on the City of Venus website.',
        cta: 'View Minutes & Agendas →',
    },
    news: { title: 'Latest News' },
    contact: {
        title: 'Contact',
        addressLabel: 'Address',
        phoneLabel: 'Phone',
        readyText: 'Ready to get started in Venus? Reach out to us by calling or sending a message.',
        sendMessage: 'Send a Message',
    },
};

export const footer = {
    tagline: 'Fostering growth and supporting the community. Experience the charm, embrace the future.',
    quickLinks: 'Quick Links',
    links: ['Why Venus', 'Site Selection', 'Business Resources', 'Properties', 'About Us'],
    contactUs: 'Contact Us',
    allRights: 'Venus Economic Development Corporation. All Rights Reserved.',
};

export const contactModal = {
    title: 'Get in Touch',
    subtitle: 'Fill out the form and a member of our team will be in touch shortly.',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email Address',
    phone: 'Phone Number',
    company: 'Company / Organization',
    companyPlaceholder: 'Optional',
    message: 'Message',
    messagePlaceholder: 'How can we help you?',
    submit: 'Send Message',
    sending: 'Sending…',
    successTitle: 'Message Sent!',
    successBody: 'Thank you for reaching out. We will get back to you within 1–2 business days.',
    errorBody: 'Something went wrong. Please try again or email us directly at contact@venustxedc.com',
    close: 'Close',
    required: 'Required field',
};

export const boardMemberProfile = {
    notFound: 'Member not found',
    backHome: '← Back to home',
    backTeam: '← Back to team',
    about: 'About',
    achievements: 'Achievements',
    contact: 'Contact',
    phone: 'Phone',
    email: 'Email',
    org: 'Organization',
    address: 'Address',
    orgValue: 'Venus Community Service\nDevelopment Corporation',
    addressValue: '700 W US Highway 67\nVenus, Texas 76084',
    sendMessage: 'Send a message',
    formName: 'Your name',
    formEmail: 'Your email',
    formMessage: 'Your message',
    formSend: 'Send',
    messageSent: 'Message sent. Thank you.',
};
